 $(".upsell-atc").on("click", function(e){
        
        e.preventDefault();
        e.stopPropagation();
        var variant_id = $(this).attr("data-variant-id");
        $("#upsell_form .upsell-id").val(variant_id);
        $("#upsell_form").trigger("submit");

    });